// src/components/Index/Tutor-section.tsx
import React from "react";

interface TutorItem {
  id: number;
  name: string;
  img: string;
  tags: string[];
  imgClass?: string;
}

const tutorsData: TutorItem[] = [
  {
    id: 1,
    name: "Ida Fitriyah",
    img: "/Mentor/Ida-nobg.png",
    tags: ["Certified BIPA Instructor", "Beginner Friendly"],
    imgClass: "h-[660px]",
  },
  {
    id: 2,
    name: "Dian Rachmatika",
    img: "/Mentor/Dira-nobg.png",
    tags: ["5+ Years Experience", "Culture Focused"],
    imgClass: "h-[550px]",
  },
];

const TutorSection: React.FC = () => {
  return (
    <section className="w-full bg-[#FDFDFD] py-20 lg:py-24 px-6 relative overflow-hidden">
      <div className="max-w-[1240px] mx-auto w-full">
        {/* --- Header Section (Frame 15 di Figma) --- */}
        <div
          className="flex flex-col items-center text-center max-w-[624px] mx-auto mb-16 lg:mb-20"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          {/* Badge: Best Tutors */}
          <div className="inline-flex items-center px-3 py-1 bg-[#FEE6E6] border border-[#C60302] rounded-full mb-4">
            <span className="font-poppins font-normal text-xs text-[#C60302] leading-none">
              Best Tutors
            </span>
          </div>

          {/* Headline */}
          <h2 className="font-montserrat font-bold text-3xl sm:text-4xl lg:text-[40px] text-[#202020] leading-[1.2] lg:leading-[48px] tracking-tight mb-4">
            Learn Indonesian Easily from Certified Local Experts
          </h2>

          {/* Subtitle */}
          <p className="font-montserrat font-normal text-base sm:text-lg lg:text-[20px] text-[#6A6A6A] leading-relaxed lg:leading-[28px]">
            Build your speaking confidence through structured, flexible classes with top-rated native BIPA tutors.
          </p>
        </div>

        {/* --- 2 Kartu Tutor (Ida & Dira) --- */}
        <div className="flex flex-col md:flex-row justify-center items-center gap-8 lg:gap-14 max-w-[880px] mx-auto">
          {tutorsData.map((tutor, idx) => (
            <div
              key={tutor.id}
              className="relative w-full max-w-[397px] h-[433px] mt-24 lg:mt-28 group"
              data-aos="fade-up"
              data-aos-delay={idx * 150}
              data-aos-duration="1000"
            >
              {/* Background Gradien Kartu (Rectangle 32)*/}
              <div className="absolute inset-x-0 bottom-0 top-[95px] bg-[linear-gradient(220.05deg,#FEE6E6_0%,#C60302_100%)] rounded-[24px] shadow-sm group-hover:shadow-lg transition-shadow duration-300" />

              {/* Kontainer Foto Tutor dengan Efek Pop-out 3D (Menyembul Lebih Tinggi) */}
              <div className="absolute inset-x-0 bottom-0 top-[-180px] overflow-hidden rounded-b-[24px] pointer-events-none flex justify-center items-end">
                <img
                  src={tutor.img}
                  alt={tutor.name}
                  className={`${tutor.imgClass || "h-[550px]"} w-auto max-w-none object-contain object-bottom select-none transition-transform duration-500 ease-out group-hover:scale-105`}
                />
              </div>

              {/* Kotak Informasi Gelap Glassmorphism (Title di Figma) */}
              <div className="absolute bottom-4 inset-x-4 h-[116px] bg-[rgba(32,32,32,0.4)] backdrop-blur-md rounded-[16px] border border-white/10 shadow-[0_6px_12px_rgba(32,32,32,0.1)] px-5 py-3.5 flex flex-col justify-center z-10">
                {/* Nama Tutor */}
                <h3 className="font-montserrat font-bold text-xl sm:text-2xl text-white leading-tight mb-2 truncate">
                  {tutor.name}
                </h3>

                {/* Checklist Spesialisasi (Value tags) */}
                <div className="flex flex-col gap-1.5">
                  {tutor.tags.map((tag, tagIdx) => (
                    <div
                      key={tagIdx}
                      className="flex items-center gap-2 text-white/95"
                    >
                      {/* akar-icons:circle-check SVG */}
                      <svg
                        className="w-4 h-4 flex-shrink-0 text-white"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="10"
                          cy="10"
                          r="8"
                          stroke="#F5F5F5"
                          strokeWidth="1.5"
                        />
                        <path
                          d="M6.5 10.2L8.8 12.5L13.5 7.8"
                          stroke="#F5F5F5"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <span className="font-montserrat font-normal text-xs sm:text-sm text-white leading-none truncate">
                        {tag}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TutorSection;
